// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDVCzRlWgcfrcH33YQG4on3NyTsnX4xzzA",
  authDomain: "topcouture-af6d4.firebaseapp.com",
  projectId: "topcouture-af6d4",
  storageBucket: "topcouture-af6d4.appspot.com",
  messagingSenderId: "1004050010083",
  appId: "1:1004050010083:web:fabb210190ed1c5985dad6",
  measurementId: "G-0PDRPSEPM5"
};

let firbaseVapidKey = "BAbXzQRZ-uPl03ZEvUnegGDNE6E7alNLnq0EqJRVlSluDLn8RGNHb0nVf1SktdIPhptbCI0muSrMXvjaShXmY9o";

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const firebaseAuth = getAuth(app);

export const getFcmToken = async () => {
  try {
    const supported = await isSupported();
    if (!supported) {
      console.log("Firebase Messaging is not supported in this browser.");
      return '';
    }
    const messaging = getMessaging(app);
    const currentToken = await getToken(messaging, { vapidKey: firbaseVapidKey });
    return currentToken;
  } catch (error) {
    console.log('An error occurred while retrieving token ::::: ', error);
    return '';
  }
};

// RESPONSIBLE FOR FIRING NOTIFICATION
export const onMessageListener = async (navRec) => {
  try {
    const supported = await isSupported();
    if (!supported) return;
    const messaging = getMessaging(app);
    onMessage(messaging, (payload) => {
      navRec(payload);
    });
  } catch (error) {
    console.log('Error in onMessageListener:', error);
  }
};